/* POS-18027 — Dues partial lock.
   Segments the app can lock when a restaurant's payment is overdue. */
export enum DuesSegment {
  REPORTS = 'REPORTS',
  ANALYTICS = 'ANALYTICS',
  MENU = 'MENU',
}

/* Wire keys as they appear in the `blockedDuesPending` array on the restaurant document.
   The restaurant keys are read from the logged-in restaurant; the hq keys are read from
   each outlet and mean "hide this outlet from HQ views". */
export const DUES_WIRE_KEYS: Record<DuesSegment, { restaurant: string; hq: string }> = {
  [DuesSegment.REPORTS]: { restaurant: 'reports', hq: 'hq_reports' },
  [DuesSegment.ANALYTICS]: { restaurant: 'report_analytics', hq: 'hq_report_analytics' },
  [DuesSegment.MENU]: { restaurant: 'menu', hq: 'hq_menu' },
};

export const DUES_LOCK_STORAGE_KEY = 'duesLock';
